import type { AutocompleteRenderInputParams } from '@mui/material/Autocomplete';
import { MultipleAutocomplete } from '@src/common/components/Autocomplete';
import { TextInput } from '@src/common/components/TextInput';
import type { SearchPermitFilters } from '@src/permits/services/PermitApplicationClient';
import { useTranslation } from 'react-i18next';

interface Props {
  onFilterChange: (filters: SearchPermitFilters) => void;
  value?: string[];
  options?: string[];
}

export const PermitJurisdictionFilter = ({
  onFilterChange,
  value = [],
  options = [],
}: Props) => {
  const { t } = useTranslation();

  const getOptionLabel = (option: unknown) => {
    return typeof option === 'string' ? option : '';
  };

  const renderInput = (params: AutocompleteRenderInputParams) => (
    <TextInput {...params} label={t('permitSearch.jurisdictionSelect')} />
  );

  const jurisdictionOptions = options.sort();

  const selectedOptions = jurisdictionOptions.filter((option) =>
    value.includes(option),
  );

  return (
    <MultipleAutocomplete
      value={selectedOptions}
      onChange={(_, selectedValues: unknown) => {
        const jurisdictions = (selectedValues as string[]).filter(
          (val): val is string => Boolean(val),
        );
        onFilterChange({ jurisdiction: jurisdictions });
      }}
      options={jurisdictionOptions}
      getOptionLabel={getOptionLabel}
      renderInput={renderInput}
    />
  );
};
